module.exports = __webpack_public_path__ + "img/map-label-bg.2379d25a.png";